export default __webpack_public_path__ + "static/media/upload-up-arrow.6d1db2d4.svg";